<div class="selecionar-pergunta-modal__overlay" (click)="onFechar()">
  <div
    class="selecionar-pergunta-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="selecionar-pergunta-modal-title"
    data-testid="selecionar-pergunta-modal"
    (click)="$event.stopPropagation()"
  >
    <h2 id="selecionar-pergunta-modal-title" class="selecionar-pergunta-modal__title">
      Selecionar pergunta já cadastrada
    </h2>

    <input
      type="text"
      class="form-control campanha-form-control"
      placeholder="Buscar por enunciado"
      [value]="filtro()"
      (input)="onFiltroChange($any($event.target).value)"
      data-testid="selecionar-pergunta-filtro"
    />

    <div class="selecionar-pergunta-modal__lista">
      @if (carregando()) {
        <p class="questionario-empty-state" data-testid="selecionar-pergunta-carregando">
          Carregando perguntas...
        </p>
      } @else if (perguntasFiltradas().length === 0) {
        <p class="questionario-empty-state" data-testid="selecionar-pergunta-vazio">
          Nenhuma pergunta cadastrada encontrada.
        </p>
      } @else {
        @for (pergunta of perguntasFiltradas(); track pergunta.id) {
          <div class="selecionar-pergunta-modal__item" data-testid="selecionar-pergunta-item">
            <span class="selecionar-pergunta-modal__texto">{{ pergunta.texto }}</span>
            <button
              type="button"
              class="campanha-form-icon-btn campanha-form-icon-btn--add"
              [attr.aria-label]="'Adicionar pergunta ' + pergunta.texto"
              (click)="selecionar.emit(pergunta)"
              data-testid="btn-selecionar-pergunta"
            >
              +
            </button>
          </div>
        }
      }
    </div>

    <div class="selecionar-pergunta-modal__actions">
      <button
        type="button"
        class="btn-primary"
        data-testid="selecionar-pergunta-fechar"
        (click)="onFechar()"
      >
        Fechar
      </button>
    </div>
  </div>
</div>
